import { useEffect, useRef, useState } from "react";
import "./style.css"
import { useDispatch } from "react-redux";
import { setMessage, setWait } from "../../redux";
import { useLogout } from "../../hooks/useLogout";

const professions = [
    "Aide soignante", "Audioprothésiste", "Dentiste", "Diététicien", "Educateur spécialisé", "Ergothérapeute",
    "Infirmier / IDE", "Kinésithérapeute", "Médecin", "Orthophoniste", "Ostéopathe",
    "Pédicure-podologue", "Pharmacien", "Psychologue", "Sage-femme", "Sophrologue"
]

const communications = ["Téléphone", "SMS", "Email professionnel", "MSSanté", "Logiciel patient", "Visio / Teams", "Secrétariat"];

const contacts = ["Téléphone direct", "Téléphone secrétariat", "SMS", "Email professionnel", "MSSanté", "Logiciel patient", "Impossible dans ce délai"];

const publics = ["Sportifs", "Enfants", "Adolescents", "Femmes enceintes", "Personnes âgées", "Personnes en situation de handicap", "Soins palliatifs", "Douleurs chroniques", "Troubles psy / anxiété"];

function Home() {
    const logout = useLogout();
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);

    const [profil, showProfil] = useState(null);
    const [filters, showFilters] = useState(false);
    const [search, setSearch] = useState({
        bar: '',
        profession: [],
        patientComTool: [],
        adminComTool: [],
        interproTool: [],
        meetingTool: [],
        urgentContact: [],
        dailyContact: [],
        weeklyContact: [],
        targetAudiences: []
    });

    const handleValue = (field, e) => {
        const value = e?.target?.value || e;

        if (field === 'bar') {
            setSearch({
                ...search,
                [field]: value
            })
            return
        }

        setSearch({
            ...search,
            [field]: search[field].includes(value)
                ? search[field].filter(p => p !== value)
                : [...search[field], value]
        });
    }

    useEffect(() => {
        const fetchUsers = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/users/get`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
            });
            const res = await req.json();
            dispatch(setWait(-1));

            if (req.status !== 200) alert(res.message);

            if (req.status === 404 || req.status === 401) {
                logout();
                return;
            }
            setUsers(res);
        }
        dispatch(setWait(1));
        fetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const results = users.filter(user => {
        const searchValue = search.bar.toLowerCase();

        // 🔍 Recherche globale
        const matchSearch =
            user.lastName?.toLowerCase().includes(searchValue) ||
            user.firstName?.toLowerCase().includes(searchValue) ||
            user.profession?.toLowerCase().includes(searchValue) ||
            user.mainLocation?.toLowerCase().includes(searchValue) ||
            user.secondaryLocations?.toLowerCase().includes(searchValue) ||
            user.proPhone?.toLowerCase().includes(searchValue) ||
            user.secretaryPhone?.toLowerCase().includes(searchValue) ||
            user.proEmail?.toLowerCase().includes(searchValue) ||
            user.secureProEmail?.toLowerCase().includes(searchValue);

        // 🎯 Filtre profession (multi choix)
        const matchProfession =
            search.profession.length === 0 ||
            search.profession.some(p =>
                p.toLowerCase() === user.profession?.toLowerCase()
            );

        // 🧠 helper pour tableaux
        const includesOne = (userArray = [], filterArray = []) =>
            filterArray.length === 0 ||
            filterArray.some(f =>
                userArray.some(u => u.toLowerCase().includes(f.toLowerCase()))
            );

        // 🔽 filtres avancés
        const matchAdvanced =
            includesOne(user.patientComTool, search.patientComTool) &&
            includesOne(user.adminComTool, search.adminComTool) &&
            includesOne(user.interproTool, search.interproTool) &&
            includesOne(user.meetingTool, search.meetingTool) &&
            includesOne(user.urgentContact, search.urgentContact) &&
            includesOne(user.dailyContact, search.dailyContact) &&
            includesOne(user.weeklyContact, search.weeklyContact) &&
            includesOne(user.targetAudiences, search.targetAudiences);

        return matchSearch && matchProfession && matchAdvanced;
    });

    const requestAccess = async (_id) => {
        dispatch(setWait(1));

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/request-access/${_id}`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
        });
        const res = await req.json();
        dispatch(setWait(-1));

        if (req.status !== 200) alert(res.message);

        if (req.status === 404 || req.status === 401) {
            logout();
            return;
        }

        setTimeout(() => {
            showProfil(null);
            dispatch(setMessage('Votre demande à été envoyé avec succès'));
            setTimeout(() => dispatch(setMessage()), 2000);
        }, 500);
    }

    return (
        <div className="page_home">
            <div className="search">
                <div className="bar">
                    <input
                        type="text"
                        placeholder="Nom / Prénom / Profession / Lieu..."
                        onChange={(e) => handleValue('bar', e)}
                        value={search.bar}
                    />
                    <i className="fas fa-magnifying-glass"></i>
                </div>

                <div className="filters_bar">
                    {professions.map((prof) => (
                        <button
                            key={prof}
                            className={search.profession.includes(prof) ? 'actif' : ''}
                            onClick={() => handleValue('profession', prof)}
                        >
                            {prof}
                        </button>
                    ))}
                </div>

                <button
                    className="filter_more_btn"
                    onClick={() => showFilters(!filters)}
                >
                    {filters ? 'Moins' : 'Plus'} de filtres
                </button>

                {filters &&
                    <MoreFilters
                        search={search}
                        handleValue={handleValue}
                    />
                }
            </div>

            <ul className="results">
                {results.length !== 0 && results.map((user, idx) => (
                    <li className="onglet" onClick={() => showProfil(user)} key={idx}>
                        <p><span>Profession :</span> {user.profession}</p>
                        <p><span>Nom et Prénom :</span> {user.lastName} {user.firstName}</p>
                        <p><span>Lieu d'exercice :</span> {user.mainLocation}</p>
                        <p><span>Note :</span> {user.importantInfo || 'Aucune note'}</p>
                    </li>
                ))}
                {results.length === 0 && <h3>Aucun résultat</h3>}
            </ul>

            {profil && <DetailsProfil profil={profil} showProfil={showProfil} requestAccess={requestAccess} />}
        </div>
    )
}

function MoreFilters({ handleValue }) {
    return (
        <div className="more_filters">
            {/* Outils communication */}
            <div className="filter_group">
                <h4>Outils de communication</h4>
                {communications.map(item => (
                    <label key={item}>
                        <input type="checkbox" onChange={(e) => handleValue('patientComTool', e)} />
                        {item}
                    </label>
                ))}
            </div>

            {/* Contact */}
            <div className="filter_group">
                <h4>Modalités de contact</h4>
                {contacts.map(item => (
                    <label key={item}>
                        <input type="checkbox" onChange={(e) => handleValue('urgentContact', e)} />
                        {item}
                    </label>
                ))}
            </div>

            {/* Publics */}
            <div className="filter_group">
                <h4>Publics concernés</h4>
                {publics.map(item => (
                    <label key={item}>
                        <input type="checkbox" onChange={(e) => handleValue('targetAudiences', e)} />
                        {item}
                    </label>
                ))}
            </div>

        </div>
    );
}

function DetailsProfil({ profil, showProfil, requestAccess }) {
    const contentRef = useRef();

    useEffect(() => {
        function handleClickOutside(e) {
            if (contentRef.current && !contentRef.current.contains(e.target)) {
                showProfil(null);
            }
        }

        if (profil) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profil]);

    const communications_array = [
        { label: "Au sujet d’un patient :", items: profil.patientComTool || [], other: profil.otherPatientComTool || '' },
        { label: "Les échanges administratifs :", items: profil.adminComTool || [], other: profil.otherAdminComTool || '' },
        { label: "Avis ou un conseil interprofessionnel :", items: profil.interproTool || [], other: profil.otherInterproTool || '' },
        { label: "Pour organiser une réunion :", items: profil.meetingTool || [], other: profil.otherMeetingTool || '' }
    ];
    const contacts_array = [
        { label: "En cas d’urgence (< 2 heures) :", items: profil.urgentContact || [], other: profil.otherUrgentContact || '' },
        { label: "Pour une réponse sous 24 heures :", items: profil.dailyContact || [], other: profil.otherDailyContact || '' },
        { label: "Pour un délai d’environ une semaine :", items: profil.weeklyContact || [], other: profil.otherWeeklyContact || '' }
    ];

    const renderContact = (value, type) => {
        if (!profil.access) return 'Données privée';
        if (!value) return 'Aucune données';

        if (type === 'tel') {
            return <a href={`tel:${value}`}>{value}</a>;
        }

        if (type === 'mail') {
            return <a href={`mailto:${value}`}>{value}</a>;
        }

        return value;
    };

    return (
        <div className="show_profil">
            <i className="fas fa-xmark"></i>

            <div className="content" ref={contentRef}>
                <h2>Fiche Personnelle Annuaire PSOA</h2>

                <div className="lists">
                    <ul>
                        <li><h3>Identité du professionnel</h3></li>
                        <li>
                            <span>Nom et Prénom :</span>
                            <p>{profil.lastName} {profil.firstName}</p>
                        </li>
                        <li>
                            <span>Profession :</span>
                            <p>{profil.profession}</p>
                        </li>
                        <li>
                            <span>Lieu d’exercice :</span>
                            <p>{profil.mainLocation}</p>
                        </li>
                        <li>
                            <span>Adresse professionnelle :</span>
                            <p>{profil.access ? (profil.secondaryLocations || 'Aucune données') : 'Données privée'}</p>
                        </li>
                    </ul>

                    <ul>
                        <li><h3>Coordonnées du professionnel</h3></li>
                        <li>
                            <span>Téléphone direct :</span>
                            <p>{renderContact(profil.proPhone, 'tel')}</p>
                        </li>
                        <li>
                            <span>Téléphone secrétariat :</span>
                            <p>{renderContact(profil.secretaryPhone, 'tel')}</p>
                        </li>
                        <li>
                            <span>Email professionnel :</span>
                            <p>{renderContact(profil.proEmail, 'mail')}</p>
                        </li>
                        <li>
                            <span>Email professionnel sécurisé :</span>
                            <p>{renderContact(profil.secureProEmail, 'mail')}</p>
                        </li>
                    </ul>

                    <ul>
                        <li><h3>Outils de communication</h3></li>

                        {communications_array.map((category, catIdx) => (
                            <li key={catIdx}>
                                <span>{category.label}</span>
                                {category && category.items.length > 0 &&
                                    <p>
                                        {category.items.length > 0 && category.items.map((e, idx) =>
                                            e !== 'AUTRE' && <t key={idx}>{e}{idx !== category.items.length - 1 && ', '}</t>
                                        )}
                                        {category.other && <t>{category.other}</t>}
                                    </p>
                                }
                                {category.items.length === 0 && <p>{profil.access ? 'Aucune données' : 'Données privée'}</p>}
                            </li>
                        ))}
                    </ul>

                    <ul>
                        <li><h3>Modalités de contact</h3></li>

                        {contacts_array.map((category, catIdx) => (
                            <li key={catIdx}>
                                <span>{category.label}</span>
                                {category && category.items.length > 0 &&
                                    <p>
                                        {category.items.length > 0 && category.items.map((e, idx) =>
                                            e !== 'AUTRE' && <t key={idx}>{e}{idx !== category.items.length - 1 && ', '}</t>
                                        )}
                                        {category.other && <t>{category.other}</t>}
                                    </p>
                                }
                                {category.items.length === 0 && <p>{profil.access ? 'Aucune données' : 'Données privée'}</p>}
                            </li>
                        ))}
                    </ul>

                    <ul>
                        <li><h3>Informations attendues</h3></li>
                        <li>
                            <span>Informations attendues du médecin :</span>
                            <p>{profil.access ? (profil.infoExpected?.ide || 'Aucune données') : 'Données privée'}</p>
                        </li>
                        <li>
                            <span>Informations attendues du pharmacien :</span>
                            <p>{profil.access ? (profil.infoExpected?.pharmacist || 'Aucune données') : 'Données privée'}</p>
                        </li>
                        <li>
                            <span>Informations attendues de l’Infirmier / IDE :</span>
                            <p>{profil.access ? (profil.infoExpected?.physiotherapist || 'Aucune données') : 'Données privée'}</p>
                        </li>
                    </ul>

                    <ul>
                        <li><h3>Informations importantes</h3></li>

                        <li>
                            <span>Publics de prédilection :</span>
                            {profil.targetAudiences && profil.targetAudiences.length > 0 &&
                                <p>
                                    {profil.targetAudiences && profil.targetAudiences.length > 0 && profil.targetAudiences.map((e, idx) => e !== 'AUTRE' &&
                                        <t key={idx}>{e}{idx !== profil.targetAudiences.length - 1 && ', '}</t>
                                    )}
                                    {profil.otherTargetAudiences && <t>{profil.otherTargetAudiences}</t>}
                                </p>
                            }
                            {!profil.targetAudiences && <p>Données privée</p>}
                        </li>
                        <li>
                            <span>Notes importantes :</span>
                            <p>{profil.importantInfo || 'Aucune données'}</p>
                        </li>
                    </ul>
                </div>

                {!profil.access &&
                    <button
                        className="btn_request_full_profil"
                        onClick={() => requestAccess(profil._id)}
                    >
                        Demander à voir la fiche complète
                    </button>
                }
            </div>
        </div>
    );
}

export default Home;